export interface ITokenPrice {
  high24h: number;
  low24h: number;
  currentPrice: number;
  current: number;
  priceChangePercentage24h: number;
  priceChangePercentage24H: number;
  chainId: number;
  address: string;
  symbol: string;
  lastUpdated: number;
  decimals: number;

  imageUrl: string;

  updateTime: number;
}

export type ITokenPriceMap = {
  [tokenAddress in string]: ITokenPrice;
};
export enum PollingHistoryId {
  trade = 'trade',
  order = 'order',
  liquidity = 'liquidity',
  transfer = 'transfer',
}

// ===== GLOBAL TOKEN PRICE API =====
// URL: /v3/public/token/allPrice

export interface FetchTokenPriceMapInput {
  chainId?: number;
}

export type FetchTokenPriceMapResponse = ITokenPriceMap;
